import React from 'react';
import { cn } from '../../lib/utils'; // Assuming utils exists or I'll create a simple helper inline if needed, but standard pattern usually implies classnames/clsx. I'll stick to simple prop concatenation for now to be safe if utils doesn't exist.
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none active:scale-95';
  const variants = {
    primary: 'bg-yellow-400 text-gray-900 hover:bg-yellow-300 shadow-lg shadow-yellow-400/20 border-2 border-transparent',
    secondary: 'bg-white text-pink-600 hover:bg-gray-50 shadow-md border-2 border-transparent',
    outline: 'bg-transparent border-2 border-white text-white hover:bg-white/10'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-12 px-6 text-base',
    lg: 'h-14 px-8 text-lg md:text-xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className || ''}`} {...props} data-id="element-236">
      {children}
    </button>;
}